// extracted by mini-css-extract-plugin
module.exports = {"popup_container":"styles_popup_container__F9g7C","dark":"styles_dark__QilPB","light":"styles_light__YpqdA"};